import { render, staticRenderFns } from "./event-icon.vue?vue&type=template&id=7b1f96f5&"
import script from "./event-icon.vue?vue&type=script&lang=js&"
export * from "./event-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
installComponents(component, {VAvatar})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b1f96f5')) {
      api.createRecord('7b1f96f5', component.options)
    } else {
      api.reload('7b1f96f5', component.options)
    }
    module.hot.accept("./event-icon.vue?vue&type=template&id=7b1f96f5&", function () {
      api.rerender('7b1f96f5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/consolidator/components/event-icon/event-icon.vue"
export default component.exports